import styled from "styled-components/macro";

export default styled.div`
  .works-container {
    background-color: ${({ theme }) => theme?.colors?.["0"]};
    text-align: center;
    padding: 40px 24px 60px 24px;
  }

  .work-grid-item {
    padding: 16px;
    display: flex;
    justify-content: center;
  }

  .work-card {
    width: 100%;
    max-width: 400px;
    border-radius: 16px;
    overflow: hidden;
    background: ${({ theme }) => theme?.colors?.["0"]};
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    position: relative;

    &:hover {
      transform: translateY(-12px) scale(1.02);
      box-shadow: 0 20px 60px rgba(1, 183, 255, 0.3);
    }
  }

  .work-image-container {
    position: relative;
    overflow: hidden;
    aspect-ratio: 16/10;
  }

  .work-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s ease;
  }

  .work-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(1, 183, 255, 0.9) 0%,
      rgba(68, 240, 181, 0.9) 100%
    );
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.4s ease;
    backdrop-filter: blur(2px);
  }

  .work-content {
    text-align: center;
    transform: translateY(30px);
    transition: transform 0.4s ease;
    padding: 20px;
  }

  .work-title {
    color: ${({ theme }) => theme?.colors?.["0"]};
    font-size: ${({ theme }) => theme?.fonts?.["4"]};
    font-family: ${({ theme }) => theme?.fontFamily?.["1"]};
    font-weight: 600;
    margin: 0 0 20px 0;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }

  .work-btn {
    display: inline-block;
    padding: 12px 28px;
    background: ${({ theme }) => theme?.colors?.["0"]};
    color: ${({ theme }) => theme?.colors?.["2"]};
    text-decoration: none;
    border-radius: 30px;
    font-weight: 600;
    font-size: ${({ theme }) => theme?.fonts?.["1"]};
    transition: all 0.3s ease;
    border: 2px solid ${({ theme }) => theme?.colors?.["0"]};
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);

    &:hover {
      background: transparent;
      color: ${({ theme }) => theme?.colors?.["0"]};
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    }
  }

  .work-card:hover {
    .work-overlay {
      opacity: 1;
    }

    .work-content {
      transform: translateY(0);
    }

    .work-img {
      transform: scale(1.1);
    }
  }

  .triangle-parent-div {
    width: 100%;
    justify-content: center;
    display: flex;
  }

  .triangle-up {
    width: 0;
    height: 0;
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;
    border-bottom: 35px solid ${({ theme }) => theme?.colors?.["0"]};
  }

  /* Mobile Responsive */
  @media (max-width: ${({ theme }) => theme?.deviceSize?.mobile}) {
    .works-container {
      padding: 30px 16px 40px 16px;
    }

    .work-grid-item {
      padding: 12px;
    }

    .work-card {
      max-width: 100%;

      &:hover {
        transform: translateY(-8px) scale(1.01);
      }
    }

    .work-title {
      font-size: ${({ theme }) => theme?.fonts?.["3"]};
      margin-bottom: 16px;
    }

    .work-btn {
      padding: 10px 24px;
      font-size: ${({ theme }) => theme?.fonts?.["0"]};
    }

    .triangle-up {
      top: 6px !important;
    }
  }

  /* Tablet Responsive */
  @media (max-width: ${({ theme }) => theme?.deviceSize?.tablet}) {
    .works-container {
      padding: 35px 20px 50px 20px;
    }

    .work-grid-item {
      padding: 14px;
    }
  }

  /* Large screens - limit card width */
  @media (min-width: 1400px) {
    .work-card {
      max-width: 380px;
    }
  }
`;
